import React from "react";
import {
  /*FiFacebook,
  FiTwitter,
  FiInstagram,
  FiDribbble,
  FiLinkedin,
  FiGithub */
} from "react-icons/fi";

const SocialShare = [
 
  {
    name: "Traidies",
    iconLink: "img/logo/traidies.png",
    link: "https://www.traidies.com/"
  },
  {
    name: "PaidOnTime",
    iconLink: "img/logo/paidontime.png",
    link: "https://www.paidontime.app/",
  },
  {
    name: "RevWolves",
    iconLink: "img/logo/revwolves.png",
    link: "https://www.revwolves.com/"
  },
  {
    name: "BookMe",
    iconLink: "img/logo/bookme.svg",
    link: "https://www.bookme.fans/"
  }
];

const Social = () => {
  return (
    <ul>
      {SocialShare.map((val, i) => (
        <li key={i}>
          <a href={val.link} target="_blank" rel="noreferrer">
            {val.iconName || <img className="social-logo" src={val.iconLink} alt={val.name} />}
          </a>
        </li>
      ))}
    </ul>    
  );
};

export default Social;
